<template>
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2461_555)">
        <circle cx="12.2781" cy="13.222" r="1.29183" stroke="#1D1E20" stroke-width="0.972598"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6551 11.1741L14.0562 10.4794L14.673 11.5477H14.0881C14.34 11.8218 14.5303 12.1533 14.6374 12.5203H15.6557C15.9676 12.5203 16.1626 12.1826 16.0066 11.9124L14.4072 9.14208C14.2512 8.87191 13.8613 8.87191 13.7053 9.14208L12.7495 10.7975C13.0798 10.8617 13.3864 10.992 13.6551 11.1741Z" fill="#1D1E20"/>
        <rect x="4" y="7.5" width="14" height="9" rx="0.5" stroke="#1D1E20" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1H14.5V6H15.5V1C15.5 0.447715 15.0523 0 14.5 0H1.5C0.947715 0 0.5 0.447715 0.5 1V9C0.5 9.55229 0.947715 10 1.5 10H2.5V9H1.5L1.5 1Z" fill="#1D1E20"/>
        <path d="M6.5 10.5H9.5" stroke="black" stroke-linecap="round"/>
        <path d="M3.5 3H7.5" stroke="black" stroke-linecap="round"/>
        <path d="M3.5 5H6.5" stroke="black" stroke-linecap="round"/>
        <path d="M6.5 13H9.5" stroke="black" stroke-linecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_2461_555">
        <rect width="18" height="18" fill="white" transform="translate(0.5)"/>
        </clipPath>
        </defs>
    </svg>
</template>